import { updateLocal } from "../slices/localSlice";

export const update = (data) => {
  return (dispatch) => {
    dispatch(updateLocal(data));
  };
};
